<template>
  	<FlexPinSubscriptionReport />
</template>

<script>

// @ is an alias to /src
import FlexPinSubscriptionReport from "@/components/reports/Flex/PinSubscriptionReport.vue";

export default {
  name: "FlexPinSubscriptionReportView",
  components: {
    FlexPinSubscriptionReport,
  },
};
</script>
